export default __webpack_public_path__ + "static/media/google.a1169cec.webp";